import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "z-20 md:hidden py-2 text-gray-100 fixed bottom-0 inset-x-0 bg-bgLight flex justify-evenly align-middle" }
const _hoisted_2 = { class: "w-full mx-3 rounded-md flex text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus font-bold" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash font-bold" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggleTimeList')), ["prevent"])),
      class: "hover:bg-bgDark transition duration-150 w-full mx-3 py-2 rounded-md block text-center bg-dark"
    }, " Time List "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ToggleModal())),
        class: "w-full px-3 py-2 rounded-md text-center bg-primary"
      }, _hoisted_4),
      (_ctx.allSessions.length > 0)
        ? (_openBlock(), _createElementBlock("select", {
            key: 0,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSessionChange($event))),
            class: "bg-bgDark text-gray-50 px-4 py-2 rounded-md focus:outline-none"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSessions, (s, idx) => {
              return (_openBlock(), _createElementBlock("option", {
                key: idx,
                value: s.doc.name,
                selected: s.doc == _ctx.currentSession
              }, _toDisplayString(s.doc.name), 9, _hoisted_5))
            }), 128))
          ], 32))
        : _createCommentVNode("", true),
      (_ctx.currentSession)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ToggleSessionDeleteModal())),
            class: "w-full px-3 py-2 rounded-md text-center bg-red-600"
          }, _hoisted_7))
        : _createCommentVNode("", true),
      _hoisted_8
    ])
  ]))
}